import { render, staticRenderFns } from "./DialogDetallesMedico.vue?vue&type=template&id=dbb037ba&"
import script from "./DialogDetallesMedico.vue?vue&type=script&lang=js&"
export * from "./DialogDetallesMedico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports